<template>
  <div class="rank-page">
    <!-- Keep the established header component mounted so its existing user-info flow is unchanged. -->
    <Header class="rank-legacy-header"></Header>

    <main class="rank-content">
      <header class="rank-title-wrap">
        <img src="../../static/images/ranking/player_ranking_title.png" :alt="$t('rank')">
      </header>

      <nav class="rank-tabs" aria-label="Ranking period">
        <img class="rank-tabs-bg" src="../../static/images/ranking/week_month_bg.png" alt="">
        <button type="button" :class="{ active: rankType === 'week' }" @click="switchRank('week')">
          <img v-if="rankType === 'week'" src="../../static/images/ranking/week_month_act.png" alt="">
          <span>{{$t('Weekly')}}</span>
        </button>
        <button type="button" :class="{ active: rankType === 'month' }" @click="switchRank('month')">
          <img v-if="rankType === 'month'" src="../../static/images/ranking/week_month_act.png" alt="">
          <span>{{$t('Monthly')}}</span>
        </button>
      </nav>

      <section class="rank-list" :aria-label="$t('rank')">
        <div v-if="redeemList && redeemList.length === 0" class="empty-message ac">
          {{ $t('no_data') }}
        </div>
        <article v-for="(item, index) in redeemList" :key="index" class="rank-item" v-else>
          <div class="rank-badge">
            <img v-if="index < 3" class="rank-badge-img" :src="index === 0 ? '../../static/images/ranking/1st_rank.png' : (index === 1 ? '../../static/images/ranking/2nd_rank.png' : '../../static/images/ranking/3rd_rank.png')" alt="">
            <span v-else class="rank-badge-num">{{ index + 1 }}</span>
          </div>
          <div class="rank-avatar">
            <img :src="item.avatar" alt="">
          </div>
          <div class="rank-name">{{ item.mobile }}</div>
          <div class="rank-points">
            <img src="../../static/images/pt-icon.png" alt="">
            <span>{{ item.points }}</span>
          </div>
        </article>
      </section>
    </main>

    <nav class="rank-bottom-nav" aria-label="Primary">
      <img class="rank-bottom-nav-bg" src="../../static/images/home/nevigator_bg.png" alt="">
      <button class="is-current" type="button" aria-current="page">
        <img class="rank-bottom-nav-active" src="../../static/images/home/nevigator_menu_act.png" alt="">
        <img src="../../static/images/home/rank_act.png" alt="">
        <span>{{ $t('Ranking') }}</span>
      </button>
      <button type="button" @click="$router.push({ path: '/' })">
        <img src="../../static/images/home/home_act.png" alt="">
        <span>{{ $t('LiveQuizHome') }}</span>
      </button>
      <button type="button" @click="$router.push({ path: '/prize' })">
        <img src="../../static/images/home/prize.png" alt="">
        <span>{{ $t('HomeNavPrizes') }}</span>
      </button>
    </nav>
  </div>
</template>
<script>
import Header from '../components/HeaderPoint'
import Dialog from '../components/dialog'

export default {
  components: {
    Header,
    Dialog
  },
  data() {
    return {
      isShow: null,
      info: {},
      redeemList: null,
      rankType: "week",
    }
  },
  created() {
    this.getRedeem()
  },
  methods: {
    back() {
      this.$router.push({path: '/'});
    },
    switchRank(type) {
      if (this.rankType === type) return;
      this.rankType = type;
      this.getRedeem();
    },
    getRedeem() {
      let that = this
      that.$parent.loadModal(true);
      let data = {
        "type": this.rankType
      }
      that.$api.post('/api/index/rank', data, r => {
        that.redeemList = r.data
        that.$parent.loadModal(false);
      })
    },
  }
}
</script>
<style scoped>
.rank-tab-wrap {
  background: url(../../static/images/rank_type_bg.png) no-repeat center center;
  background-size: 75% 100%;
  padding: 12px 20px;
  margin-top: 20px;
  display: flex;
  justify-content: center;
}
.rank-tab-inner {
  display: flex;
  width: 100%;
  max-width: 480px;
  justify-content: center;
  align-items: center;
}
.rank-tab-item {
  flex: 1;
  text-align: center;
  font-size: 30px;
  font-weight: 700;
  color: #fff;
  padding: 16px 0;
  cursor: pointer;
  border-radius: 60px;
  transition: all 0.3s;
}
.rank-tab-item.active {
  background: url(../../static/images/rank_type_active.png) no-repeat center center;
  background-size: 100% 100%;
  color: #fff;
}

.rank-list {
  height: calc(100vh - 420px);
  overflow-y: auto;
  padding-bottom: 20px;
}
.rank-item {
  background: url(../../static/images/rank_item_bg.png) no-repeat center center;
  background-size: 95% 100%;
  margin-bottom: 20px;
  padding: 20px 24px;
  border-radius: 20px;
}
.rank-item-inner {
  display: flex;
  align-items: center;
}
.rank-badge {
  width: 100px;
  min-width: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.rank-badge-img {
  width: 90px;
  height: auto;
  margin-left: 30px;
}
.rank-badge-num {
  font-size: 56px;
  font-weight: 700;
  font-style: italic;
  color: #e8437f;
  text-shadow: 1px 1px 2px rgba(0,0,0,0.1);
}
.rank-avatar {
  width: 110px;
  min-width: 110px;
  height: 110px;
  margin: 0 20px;
}
.rank-avatar img {
  width: 110px;
  height: 110px;
  margin-left: 30px;
  border-radius: 50%;
  object-fit: cover;
  border: 4px solid #fff;
}
.rank-info {
  flex: 1;
  min-width: 0;
  margin-left: 40px;
}
.rank-name {
  font-size: 34px;
  font-weight: 700;
  color: white;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.rank-points {
  display: inline-flex;
  align-items: center;
  background: linear-gradient(180deg, #e32153, #a20f39);
  color: #fff;
  border-radius: 40px;
  padding: 6px 24px;
  margin-top: 8px;
  font-size: 26px;
  font-weight: 700;
}
.rank-points img {
  width: 30px;
  height: 30px;
  margin-right: 8px;
}
.empty-message {
  padding: 100px 0;
  font-size: 24px;
  color: #999;
}

/* Ranking redesign: presentation only; the request and response data remain unchanged. */
.rank-page {
  box-sizing: border-box;
  height: 100vh;
  min-height: 0;
  padding: 46px 28px 226px;
  overflow: hidden;
  overscroll-behavior: none;
  color: #fff;
  background: #080126 url('../../static/images/livequiz/main_bg.jpg') no-repeat center center fixed;
  background-size: cover;
  font-family: Arial, Atom-sans, sans-serif;
}
.rank-legacy-header { display: none; }
.rank-content { width: min(100%, 640px); margin: 0 auto; }
.rank-title-wrap { display: flex; height: 156px; align-items: center; justify-content: center; }
.rank-title-wrap img { display: block; width: min(110vw, 690px); height: auto; transform: translateY(50px); }
.rank-tabs { position: relative; display: flex; width: min(82%, 440px); height: 82px; margin: 84px auto 32px; align-items: center; }
.rank-tabs-bg { position: absolute; inset: 0; width: 100%; height: 100%; object-fit: fill; }
.rank-tabs button { position: relative; z-index: 1; display: flex; flex: 1 1 50%; height: 100%; align-items: center; justify-content: center; padding: 0; overflow: hidden; border: 0; background: transparent; color: rgba(255,255,255,.65); font-size: 25px; font-style: italic; font-weight: 800; }
.rank-tabs button img { position: absolute; inset: 2px 0; width: 100%; height: calc(100% - 4px); object-fit: fill; }
.rank-tabs button span { position: relative; z-index: 1; }
.rank-tabs button.active { color: #fff; }
.rank-page .rank-list { height: calc(100vh - 580px); min-height: 270px; margin: 0; padding: 0 2px 10px; overflow-y: auto; overscroll-behavior: contain; -webkit-overflow-scrolling: touch; scrollbar-width: none; }
.rank-page .rank-list::-webkit-scrollbar { width: 0; }
.rank-page .rank-item { position: relative; display: flex; min-height: 126px; margin-bottom: 16px; align-items: center; padding: 14px 18px; border-radius: 0; background: url('../../static/images/ranking/rank_item_bg.png') no-repeat center center; background-size: 100% 100%; }
.rank-page .rank-badge { display: flex; width: 108px; min-width: 108px; align-items: center; justify-content: center; }
.rank-page .rank-badge-img { display: block; width: 112px; height: auto; margin: 0; }
.rank-page .rank-badge-num { display: flex; width: 82px; height: 82px; align-items: center; justify-content: center; background: url('../../static/images/ranking/other_rank_bg.png') no-repeat center center; background-size: contain; color: #fff; font-size: 45px; font-style: italic; font-weight: 800; }
.rank-page .rank-avatar { width: 94px; min-width: 94px; height: 94px; margin: 0 16px; }
.rank-page .rank-avatar img { display: block; width: 100%; height: 100%; margin: 0; border: 3px solid #fff; border-radius: 50%; object-fit: cover; }
.rank-page .rank-name { min-width: 0; flex: 1 1 auto; margin: 0; overflow: hidden; color: #fff; font-size: 26px; font-weight: 800; letter-spacing: .2px; text-overflow: ellipsis; white-space: nowrap; }
.rank-page .rank-points { display: inline-flex; width: 184px; min-width: 184px; height: 55px; align-items: center; justify-content: center; gap: 8px; margin: 0 0 0 16px; padding: 0 8px; border-radius: 0; background: url('../../static/images/ranking/pts_bg.png') no-repeat center center; background-size: 100% 100%; color: #ffd000; font-size: 27px; font-style: italic; font-weight: 900; }
.rank-page .rank-points img { width: 36px; height: 36px; margin: 0; object-fit: contain; }
.rank-page .empty-message { padding: 100px 0; color: #fff; }
.rank-bottom-nav { position: fixed; z-index: 50; bottom: 16px; left: 50%; width: calc(100% - 56px); transform: translateX(-50%); }
.rank-bottom-nav-bg { display: block; width: 100%; }
.rank-bottom-nav button { position: absolute; top: 8%; bottom: 10%; display: flex; width: 33.33%; align-items: center; justify-content: flex-end; flex-direction: column; gap: 1px; padding: 0; border: 0; background: transparent; color: rgba(255,255,255,.62); font-size: clamp(13px, 4.4vw, 28px); font-weight: 800; line-height: 1; }
.rank-bottom-nav button:nth-of-type(2) { left: 33.33%; }
.rank-bottom-nav button:nth-of-type(3) { right: 0; }
.rank-bottom-nav button > img:not(.rank-bottom-nav-active) { position: relative; z-index: 1; width: 74px; height: 74px; object-fit: contain; }
.rank-bottom-nav button.is-current { color: #fff; }
.rank-bottom-nav-active { position: absolute; z-index: 0; top: -4px; width: 82% !important; height: auto !important; max-height: none !important; object-fit: contain; }
.rank-bottom-nav .is-current > img:not(.rank-bottom-nav-active) { width: 128px; height: 128px; margin-top: -74px; transform: translateY(-30px); }
.rank-bottom-nav .is-current span { position: relative; z-index: 1; }
@media (max-width: 560px) {
  .rank-page { padding: 45px 18px 198px; }
  .rank-title-wrap { height: 150px; }
  .rank-title-wrap img { width: 110vw; transform: translateY(20px); }
  .rank-tabs { width: 82%; height: 68px; margin: 54px auto 24px; }
  .rank-tabs button { font-size: 21px; }
  .rank-page .rank-list { height: calc(100vh - 404px); min-height: 250px; }
  .rank-page .rank-item { min-height: 94px; margin-bottom: 11px; padding: 10px 14px; }
  .rank-page .rank-badge { width: 55px; min-width: 55px; }
  .rank-page .rank-badge-img { width: 66px; }
  .rank-page .rank-badge-num { width: 54px; height: 54px; font-size: 29px; }
  .rank-page .rank-avatar { width: 54px; min-width: 54px; height: 54px; margin: 0 8px; }
  .rank-page .rank-avatar img { border-width: 2px; }
  .rank-page .rank-name { font-size: 16px; letter-spacing: 0; }
  .rank-page .rank-points { width: 102px; min-width: 102px; height: 37px; gap: 3px; margin-left: 7px; padding: 0 3px; font-size: 16px; }
  .rank-page .rank-points img { width: 22px; height: 22px; }
  .rank-bottom-nav { bottom: 9px; width: calc(100% - 36px); }
  .rank-bottom-nav button > img:not(.rank-bottom-nav-active) { width: 60px; height: 60px; }
  .rank-bottom-nav .is-current > img:not(.rank-bottom-nav-active) { width: 106px; height: 106px; margin-top: -60px; transform: translateY(-26px); }
}
</style>



// WEBPACK FOOTER //
// src/page/rank.vue